import React, {useState} from 'react';
import RetakeSearch from "./retakeSearch";
import RetakeResults from "./retakeResults";
import table_config from "./retake/table_settings";

const Retake = () => {
  //controller
  const initialState = () => {
    const queryParams = new URLSearchParams(window.location.search);
    return {
      coordinator: queryParams.get('coordinator'),
      supplier: queryParams.get('supplier'),
      language: queryParams.get('language'),
      customer: queryParams.get('customer'),
      retake: queryParams.get('retake'),
      to: queryParams.get('to') || (new Date()).toISOString().split('T')[0], //today
      from: queryParams.get('from') || (new Date(Date.now() - 12096e5)).toISOString().split('T')[0], //2 weeks ago (2 * 7 * 24 * 60 * 60 * 1000 = 12096e5)
      paid: queryParams.get('paid'),
      foundby: queryParams.get('foundby'),
      errorLevel: queryParams.get('errorLevel'),
      page: parseInt(queryParams.get('page')) || 0,
      pageSize: parseInt(queryParams.get('pageSize')) || 25
    }
  };
  const [search_paramsValue, search_paramsUpdater] = useState(initialState)
  const [update, triggerUpdate] = useState(0)
  const [download, triggerDownload] = useState(0)

  const get_csv_data = (e) => {
    e.preventDefault();
    triggerDownload(download + 1)
  };

  const get_table_data = (event) => {
    event.preventDefault();
    search_paramsUpdater({...search_paramsValue, page: 0})
    triggerUpdate(update + 1)

  };

  return (
    <div>
      <RetakeSearch search_params={search_paramsValue}
                    search_params_update={search_paramsUpdater}
                    trigger_update={(event) => get_table_data(event)}
                    trigger_download={(event) => get_csv_data(event)}
      />
      <RetakeResults search_params={search_paramsValue} download={download}
                     update={update}
                     search_params_update={search_paramsUpdater}
                     table_config={table_config}
                     triggerUpdate={triggerUpdate}/>
    </div>
  );
};

export default Retake;
